import React from 'react';
import {Table} from "./Table";


export function PeriodicElementDetailed(props) {

    return (
        <div className={"row mt-3 ms-5 bg-white w-75 p-4 border"}>



            <div className={"col-5"}>
                <div style={{backgroundColor:props.color}} className={"text-white px-3 py-2 mt-3 border mb-2 border-3 border-dark w-50"}>
                    <p style={{fontSize:"1em"}} className={" m-0 text-center"}>{props.element.atomicNumber}</p>
                    <h2 className={"text-center m-0"} style={{fontSize:"2em"}}>{props.element.symbol}</h2>
                    <p className={"text-center m-0"} style={{fontSize:"1em"}}>{props.element.name} </p>
                </div>
                <Table>
                    <tr>
                        <th>Atom masse</th>
                        <td>{props.element.atomicMass}u</td>
                    </tr>
                    <tr>
                        <th>Ladning</th>
                        <td>{props.element.charge}</td>
                    </tr>
                    <tr>
                        <th>Elektronegativitet</th>
                        <td>{props.element.electronegativity}</td>
                    </tr>

                    <tr>
                        <th>Smeltepunkt</th>
                        <td>{props.element.meltingPoint}</td>
                    </tr>

                    <tr>
                        <th>Kokepunkt</th>
                        <td>{props.element.boilingPoint}</td>
                    </tr>
                    <tr>
                        <th>Radioaktiv</th>
                        <td>{props.element.radioactive ?  "Ja" : "Nei"}</td>
                    </tr>

                </Table>

            </div>


        </div>
    );


}
